module.exports = __webpack_public_path__ + "img/4.98325371.png";